// src/components/common/GA4PageViewTracker.tsx

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../lib/analytics';

export default function GA4PageViewTracker() {
  const location = useLocation();
  const prevPathRef = useRef('');

  useEffect(() => {
    // 쿼리 스트링과 해시를 포함한 전체 경로
    const pagePath = `${location.pathname}${location.search}${location.hash}`;

    // 마지막으로 기록된 경로와 동일하다면 중복 전송 방지
    if (prevPathRef.current === pagePath) return;
    prevPathRef.current = pagePath;

    trackPageView({
      page_path: pagePath,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
